<template>
  <v-app id="app">
    <v-main>
      <template v-if="$settings?.system?.status === 'suspended'">
        <v-container justify-center fill-height>
          <div
            class="d-flex flex-column fill-height justify-center align-center text-center"
          >
            <v-icon size="4rem" color="green accent-4" class="mb-4">
              mdi-rocket-launch
            </v-icon>

            <h1 class="text-h5 font-weight-bold mb-3">
              Estamos preparando uma nova versão
            </h1>

            <p
              class="text-body-1 text--secondary mb-6"
              style="max-width: 37.5rem"
            >
              {{ $settings.system.message }}
            </p>

            <v-alert
              type="warning"
              outlined
              border="left"
              class="mt-4"
              style="max-width: 40rem"
            >
              <div class="text-body-2">
                <strong>Aviso de segurança</strong><br />
                O único site oficial do <strong>Palavra Premiada</strong> é
                <strong>https://palavrapremiada.com</strong>.<br />
                Qualquer outro domínio ou site semelhante
                <strong>não é autorizado</strong> e pode representar
                <strong>tentativa de cópia ou golpe</strong>. Utilize apenas o
                endereço oficial para sua segurança.
              </div>
            </v-alert>
          </div>
        </v-container>
      </template>

      <router-view v-else />
    </v-main>

    <AlertBar ref="alertBar" />
  </v-app>
</template>

<script>
import AlertBar from "@/components/alertBar/AlertBar";

export default {
  name: "App",

  components: {
    AlertBar,
  },

  created() {
    this.initTheme();
  },

  beforeMount() {
    this.$root.$on("alert", this.handleAlert);

    console.log(process.env.VUE_APP_ENV);
  },

  beforeDestroy() {
    this.$root.$off("alert", this.handleAlert);
  },

  methods: {
    initTheme() {
      Object.entries(this.$settings?.colorPalette).forEach(([key, value]) => {
        if (
          this.$vuetify.theme.themes.dark &&
          this.$vuetify.theme.themes.dark[key] !== undefined
        )
          this.$vuetify.theme.themes.dark[key] = value;

        if (
          this.$vuetify.theme.themes.white &&
          this.$vuetify.theme.themes.white[key] !== undefined
        )
          this.$vuetify.theme.themes.white[key] = value;
      });
    },

    handleAlert(event) {
      this.$refs.alertBar.handleAlert(event);
    },
  },
};
</script>

<style lang="scss">
html {
  background: $neutral;
}

#app {
  background: $neutral;
}
</style>
